import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createBlock as _createBlock, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74426e1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "note note-danger mt-3"
}
const _hoisted_2 = {
  key: 1,
  class: "note note-success mt-3"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Export Config")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Export your a selected identity (excluding private keys), custom Feeds, Lists, and List Groups as a JSON config file that can be imported elsewhere. In order to export private keys you must use the \"config:export\" command of the PSQR cli with the original identity. ")
const _hoisted_5 = ["value"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Export")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Import Config")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Select the appropriate config file or paste the json into the field below in order to import an ology config. Text in the text field is used over a provided file if both are present. ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Import")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("List Management")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Create and manage PSQR lists. ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "curateKeySelect"
}, "List Curate Key", -1))
const _hoisted_13 = ["value"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mt-4 form-label" }, "Import List Content", -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Import")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Lists")
const _hoisted_17 = { class: "d-flex justify-content-between align-items-center p-2" }
const _hoisted_18 = { class: "m-0" }
const _hoisted_19 = { class: "m-0" }
const _hoisted_20 = { class: "justify-content-right" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("List Groups")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Create and manage list groups. This allows you to add content to multiple lists at once. ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Create Group")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Groups")
const _hoisted_25 = { class: "d-flex justify-content-between align-items-center p-2" }
const _hoisted_26 = { class: "m-0" }
const _hoisted_27 = { class: "m-0" }
const _hoisted_28 = { class: "justify-content-right" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Feed Management")
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "curateKeySelect"
}, "Feed Edit Key", -1))
const _hoisted_31 = ["value"]
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Save")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Key Pairs")
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" These are all Key Pairs that are stored locally. ")
const _hoisted_35 = { class: "d-flex justify-content-between align-items-center p-2" }
const _hoisted_36 = { class: "m-0" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Feed Configuration: ")
const _hoisted_38 = { class: "p-3 bg-dark text-white" }

import { ref, Ref, onMounted } from "vue";
import {
    MDBAccordion,
    MDBAccordionItem,
    MDBContainer,
    MDBCard,
    MDBBtn,
    MDBTextarea,
    MDBInput,
    MDBSpinner,
    MDBCardBody,
    MDBCardTitle,
    MDBCardText,
    MDBFile,
    MDBListGroup,
    MDBListGroupItem,
    MDBIcon,
} from "mdb-vue-ui-kit";
import axios from "axios";

import { getAllLists, getAllConfigs, importConfig, importList, deleteKeyPair, deleteList, parseListKey, putListGroup, getAllListGroups, deleteListGroup, getConfig, getAllKeyPairs, getKeyPairs } from '@/functions/store';
import { extractRef } from '@/functions/utility';
import { KeyPair } from '@/types/KeyPair';
import { List } from '@/types/List';
import { ListGroup } from "@/types/ListGroup";
import { FeedConfig, FeedTemplate } from "@/types/FeedConfig";
import { PsqrConfig } from "@/types/runtypes/config";

// setup refs

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const errMsg = ref('');
const successMsg = ref('');
const configImportFile = ref();
const configImportText = ref('');
const importingConfig = ref(false);
const keyPairList: Ref<KeyPair[]> = ref([]);
const curateKeys: Ref<KeyPair[]> = ref([]);
const feedConfiguration = ref({
    test: true,
    data: [
        1, 2, 3, 4
    ]
});
const activeItemAdvanced = ref('advanced-section-1');
const feedEditKey = ref(localStorage.getItem('feedEditKey'));

// list setup
const listImportName = ref('');
const listImportEndpoint = ref('');
const listCurateKey = ref();
const listImportFile = ref();
const listImportUrl = ref('');
const importingList = ref(false);
const lists: Ref<List[]> = ref([]);

const listGroupName = ref('');
const groups: Ref<ListGroup[]> = ref([]);

// config export selection
const currentConfigs = ref([]);
const configToExport = ref('');

/**
* Parses a String for the DID JSON Config and Imports New Config
*/
async function importNewConfig() {
    // clear msg values
    errMsg.value = '';
    successMsg.value = '';

    importingConfig.value = true;
    let configString = '';
    if (configImportText.value.length > 0) {
        configString = configImportText.value;
    } else if (typeof configImportFile.value !== 'undefined') {
        configString = await configImportFile.value[0].text();
    } else {
        errMsg.value = `No config specified`;
        importingConfig.value = false;
        window.scrollTo(0, 0);
        return false;
    }

    // ensure valid json
    let config: any;
    try {
        config = JSON.parse(configString);
    } catch (error) {
        const msg = 'Invalid Config JSON due to: '
        let msgSimple = 'Unable to Verify';
        console.log(msg);
        console.error(error);

        if (error instanceof Error) {
            errMsg.value = msg + error.message;
        } else {
            errMsg.value = msg + msgSimple;
        }

        importingConfig.value = false;
        window.scrollTo(0, 0);
        return false;
    }

    // once properly imported store available configs
    const importResp = await importConfig(config);

    if (importResp.success) {
        successMsg.value = `Successfully imported the config for ${config.name} (${config.identity.didDoc.id})`;

        await updateKeyPairList();
        await updateLists();
        await updateConfigs();
    } else {
        errMsg.value = importResp.message;
        window.scrollTo(0, 0);
    }

    importingConfig.value = false;
}

async function exportConfig() {
    const did = configToExport.value;

    // get data for config object
    const config = await getConfig(did);
    delete config.identity.keyPairs;
    const lists = await getAllLists();
    const listGroups = await getAllListGroups(false);

    // get only custom feeds
    const feeds: FeedTemplate[] = [];
    const feedConfig: FeedConfig = JSON.parse(localStorage.getItem("feed_configuration"));
    for (const fname in feedConfig.feeds) {
        if (Object.prototype.hasOwnProperty.call(feedConfig.feeds, fname)) {
            const feed = feedConfig.feeds[fname];

            if (feed.canDelete) feeds.push(feed);
        }
    }

    // assemble export config
    config.feeds = feeds;
    config.lists = lists;
    config.listGroups = listGroups;

    // validate export config
    try {
        PsqrConfig.validate(config);
    } catch (error) {
        console.error(error);
        errMsg.value = `Unable to export the config for ${did}`;
        window.scrollTo(0, 0);
        return false;
    }

    // save file
    const fileName = did.replace(/[:/]/g, '-') + '-export-' + Date.now() + '.json';
    let a = document.createElement('a');
    a.href = "data:application/octet-stream," + encodeURIComponent(JSON.stringify(config));
    a.download = fileName;
    a.click();
}

async function updateConfigs() {
    const configs = await getAllConfigs();
    if (configs.length > 0) {
        currentConfigs.value = configs.map((c: any) => c.identity.didDoc.id);
        configToExport.value = configs[0].identity.didDoc.id;
    }
}

/**
* Update the Key Pair List based on all available configs
*/
async function updateKeyPairList() {
    keyPairList.value = await getAllKeyPairs();
    curateKeys.value = await getKeyPairs('curate');
}

/**
* Remove a Key Pair from the Key Pair List
*/
async function removePair(kid: string) {
    await deleteKeyPair(kid);
    const list = keyPairList.value;

    for (let i = 0; i < list.length; i++) {
        const pair = list[i];

        if (pair.kid === kid) {
            list.splice(i, 1);
            break;
        }
    }

    keyPairList.value = list;
}

/**
* Import a New List
*/
async function importNewList() {
    // clear msg values
    errMsg.value = '';
    successMsg.value = '';

    importingList.value = true;

    if (listImportName.value === '') {
        errMsg.value = `No list name specified`;
        importingList.value = false;
        window.scrollTo(0, 0);
        return false;
    }

    if (listImportEndpoint.value === '') {
        errMsg.value = `No list endpoint url specified`;
        importingList.value = false;
        window.scrollTo(0, 0);
        return false;
    }

    if (typeof listCurateKey.value === 'undefined') {
        errMsg.value = `No curate key specified`;
        importingList.value = false;
        window.scrollTo(0, 0);
        return false;
    }

    let listString = '';
    try {
        if (listImportUrl.value.length > 0) {
            const response = await axios.get(listImportUrl.value);
            listString = response.data;
        } else if (typeof listImportFile.value !== 'undefined') {
            listString = await listImportFile.value[0].text();
        }
    } catch (error) {
        const msg = 'Error retrieving list data: '
        let msgSimple = 'Unable to Verify';
        console.log(msg);
        console.error(error);

        if (error instanceof Error) {
            errMsg.value = msg + error.message;
        } else {
            errMsg.value = msg + msgSimple;
        }

        importingList.value = false;
        window.scrollTo(0, 0);
        return false;
    }

    const importResp = await importList(listImportName.value, listImportEndpoint.value, listCurateKey.value, listString);

    if (importResp.success) {
        successMsg.value = `Successfully imported the list`;
        await updateLists();
    } else {
        errMsg.value = importResp.message;
    }

    importingList.value = false;
}

/**
* Update All Lists
*/
async function updateLists() {
    const allLists = await getAllLists();
    lists.value = allLists;

    const allListGroups = await getAllListGroups();
    groups.value = allListGroups;
}

/**
* Remove List with listname from Set of Lists
*
* @param name name of list to remove
*/
async function removeList(name: string) {
    await deleteList(name);
    const currentLists = lists.value;

    for (let i = 0; i < currentLists.length; i++) {
        const list = currentLists[i];

        if (list.name === name) {
            currentLists.splice(i, 1);
            break;
        }
    }

    lists.value = currentLists;
}

async function createListGroup() {
    // clear msg values
    errMsg.value = '';
    successMsg.value = '';

    importingConfig.value = true;
    if (listGroupName.value === '') {
        errMsg.value = `No list group name specified`;
        importingConfig.value = false;
        window.scrollTo(0, 0);
        return false;
    }

    // once properly created
    const putResp = await putListGroup({
        name: listGroupName.value,
        lists: []
    });

    if (putResp.name == listGroupName.value) {
        successMsg.value = `Successfully create the list group ${listGroupName.value}`;
        await updateLists();
    } else {
        errMsg.value = `Error while creating the list group ${listGroupName.value}`;
        window.scrollTo(0, 0);
    }

    importingConfig.value = false;
}

/**
* Remove List Group with name from Set of groups
*
* @param name name of list group to remove
*/
async function removeListGroup(name: string) {
    await deleteListGroup(name);
    const currentGroups = groups.value;

    for (let i = 0; i < currentGroups.length; i++) {
        const grp = currentGroups[i];

        if (grp.name === name) {
            currentGroups.splice(i, 1);
            break;
        }
    }

    groups.value = currentGroups;
}

function setFeedEditKey() {
    localStorage.setItem('feedEditKey', extractRef(feedEditKey));
}

onMounted(async () => {
    await updateKeyPairList();
    await updateLists();
    await updateConfigs();

    feedConfiguration.value = JSON.parse(localStorage.getItem("feed_configuration") || '{}');
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(MDBContainer), null, {
    default: _withCtx(() => [
      (errMsg.value !== '')
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(errMsg.value), 1))
        : _createCommentVNode("", true),
      (successMsg.value !== '')
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(successMsg.value), 1))
        : _createCommentVNode("", true),
      (currentConfigs.value.length > 0)
        ? (_openBlock(), _createBlock(_unref(MDBCard), {
            key: 2,
            class: "mt-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(MDBCardBody), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(MDBCardTitle), null, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(MDBCardText), null, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createElementVNode("select", {
                    id: "listSelect",
                    class: "form-select",
                    "aria-label": "List to add to Group",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((configToExport).value = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentConfigs.value, (did) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: did,
                        value: did
                      }, _toDisplayString(did), 9, _hoisted_5))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, configToExport.value]
                  ]),
                  _createVNode(_unref(MDBBtn), {
                    color: "primary",
                    onClick: exportConfig,
                    class: "mt-3"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(MDBCard), { class: "mt-3" }, {
        default: _withCtx(() => [
          _createVNode(_unref(MDBCardBody), null, {
            default: _withCtx(() => [
              _createVNode(_unref(MDBCardTitle), null, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_unref(MDBCardText), null, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }),
              _createVNode(_unref(MDBFile), {
                class: "mt-3",
                modelValue: configImportFile.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((configImportFile).value = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(MDBTextarea), {
                class: "mt-3",
                label: "Import Config Text",
                rows: "8",
                modelValue: configImportText.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((configImportText).value = $event))
              }, null, 8, ["modelValue"]),
              (importingConfig.value)
                ? (_openBlock(), _createBlock(_unref(MDBSpinner), {
                    key: 0,
                    class: "mt-3"
                  }))
                : (_openBlock(), _createBlock(_unref(MDBBtn), {
                    key: 1,
                    color: "primary",
                    onClick: importNewConfig,
                    class: "mt-3"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(MDBCard), { class: "mt-3" }, {
        default: _withCtx(() => [
          _createVNode(_unref(MDBCardBody), null, {
            default: _withCtx(() => [
              _createVNode(_unref(MDBCardTitle), null, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }),
              _createVNode(_unref(MDBCardText), null, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }),
              _createVNode(_unref(MDBInput), {
                class: "my-4",
                type: "text",
                size: "lg",
                label: "Import List Name",
                modelValue: listImportName.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((listImportName).value = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(MDBInput), {
                class: "my-4",
                type: "text",
                size: "lg",
                label: "Import List Url Endpoint",
                modelValue: listImportEndpoint.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((listImportEndpoint).value = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_12,
              _withDirectives(_createElementVNode("select", {
                id: "curateKeySelect",
                class: "form-select",
                "aria-label": "List Curate Key",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((listCurateKey).value = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(curateKeys.value, (pair) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: 'curatekeys-' + pair.kid,
                    value: pair.kid
                  }, _toDisplayString(pair.kid), 9, _hoisted_13))
                }), 128))
              ], 512), [
                [_vModelSelect, listCurateKey.value]
              ]),
              _hoisted_14,
              _createVNode(_unref(MDBFile), {
                modelValue: listImportFile.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((listImportFile).value = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(MDBInput), {
                class: "mt-3",
                type: "url",
                label: "Import Content Url",
                modelValue: listImportUrl.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((listImportUrl).value = $event))
              }, null, 8, ["modelValue"]),
              (importingList.value)
                ? (_openBlock(), _createBlock(_unref(MDBSpinner), {
                    key: 0,
                    class: "mt-3"
                  }))
                : (_openBlock(), _createBlock(_unref(MDBBtn), {
                    key: 1,
                    color: "primary",
                    onClick: importNewList,
                    class: "my-3"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  })),
              (lists.value.length > 0)
                ? (_openBlock(), _createBlock(_unref(MDBCardTitle), { key: 2 }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_unref(MDBListGroup), null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lists.value, (list) => {
                    return (_openBlock(), _createBlock(_unref(MDBListGroupItem), {
                      key: list.name
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("h4", _hoisted_18, [
                            _createVNode(_unref(MDBIcon), {
                              icon: "bars",
                              iconStyle: "fas"
                            }),
                            _createTextVNode(" " + _toDisplayString(list.name), 1)
                          ]),
                          _createElementVNode("p", _hoisted_19, _toDisplayString(list.articles.length) + " articles", 1),
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_unref(MDBBtn), {
                              color: "primary",
                              floating: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_router_link, {
                                  to: { name: 'List', params: { listKey: _unref(parseListKey)(list.name) } }
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(MDBIcon), {
                                      icon: "edit",
                                      iconStyle: "fas"
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_unref(MDBBtn), {
                              color: "danger",
                              onClick: ($event: any) => (removeList(list.name)),
                              floating: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(MDBIcon), {
                                  icon: "trash",
                                  iconStyle: "fas"
                                })
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(MDBCard), { class: "mt-3" }, {
        default: _withCtx(() => [
          _createVNode(_unref(MDBCardBody), null, {
            default: _withCtx(() => [
              _createVNode(_unref(MDBCardTitle), null, {
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 1
              }),
              _createVNode(_unref(MDBCardText), null, {
                default: _withCtx(() => [
                  _hoisted_22
                ]),
                _: 1
              }),
              _createVNode(_unref(MDBInput), {
                class: "my-4",
                type: "text",
                size: "lg",
                label: "List Group Name",
                modelValue: listGroupName.value,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((listGroupName).value = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(MDBBtn), {
                color: "primary",
                onClick: createListGroup,
                class: "my-3"
              }, {
                default: _withCtx(() => [
                  _hoisted_23
                ]),
                _: 1
              }),
              (groups.value.length > 0)
                ? (_openBlock(), _createBlock(_unref(MDBCardTitle), { key: 0 }, {
                    default: _withCtx(() => [
                      _hoisted_24
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_unref(MDBListGroup), null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groups.value, (group) => {
                    return (_openBlock(), _createBlock(_unref(MDBListGroupItem), {
                      key: group.name
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("h4", _hoisted_26, [
                            _createVNode(_unref(MDBIcon), {
                              icon: "th-list",
                              iconStyle: "fas"
                            }),
                            _createTextVNode(" " + _toDisplayString(group.name), 1)
                          ]),
                          _createElementVNode("p", _hoisted_27, _toDisplayString(group.lists.length) + " lists", 1),
                          _createElementVNode("div", _hoisted_28, [
                            _createVNode(_unref(MDBBtn), {
                              color: "primary",
                              floating: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_router_link, {
                                  to: { name: 'List Group', params: { groupKey: _unref(parseListKey)(group.name) } }
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(MDBIcon), {
                                      icon: "edit",
                                      iconStyle: "fas"
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_unref(MDBBtn), {
                              color: "danger",
                              onClick: ($event: any) => (removeListGroup(group.name)),
                              floating: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(MDBIcon), {
                                  icon: "trash",
                                  iconStyle: "fas"
                                })
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(MDBCard), { class: "mt-3" }, {
        default: _withCtx(() => [
          _createVNode(_unref(MDBCardBody), null, {
            default: _withCtx(() => [
              _createVNode(_unref(MDBCardTitle), null, {
                default: _withCtx(() => [
                  _hoisted_29
                ]),
                _: 1
              }),
              _hoisted_30,
              _withDirectives(_createElementVNode("select", {
                id: "feedEditSelect",
                class: "form-select",
                "aria-label": "Feed Edit Key",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((feedEditKey).value = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(curateKeys.value, (pair) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: 'feedEditKeys-' + pair.kid,
                    value: pair.kid
                  }, _toDisplayString(pair.kid), 9, _hoisted_31))
                }), 128))
              ], 512), [
                [_vModelSelect, feedEditKey.value]
              ]),
              _createVNode(_unref(MDBBtn), {
                color: "primary",
                onClick: setFeedEditKey,
                class: "my-3"
              }, {
                default: _withCtx(() => [
                  _hoisted_32
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (keyPairList.value.length > 0)
        ? (_openBlock(), _createBlock(_unref(MDBCard), {
            key: 3,
            class: "mt-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(MDBCardBody), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(MDBCardTitle), null, {
                    default: _withCtx(() => [
                      _hoisted_33
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(MDBCardText), null, {
                    default: _withCtx(() => [
                      _hoisted_34
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(MDBListGroup), null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(keyPairList.value, (pair) => {
                        return (_openBlock(), _createBlock(_unref(MDBListGroupItem), {
                          key: 'allkeys-' + pair.kid
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("h4", _hoisted_36, [
                                _createVNode(_unref(MDBIcon), {
                                  icon: "key",
                                  iconStyle: "fas fa"
                                }),
                                _createTextVNode(" " + _toDisplayString(pair.kid), 1)
                              ]),
                              _createVNode(_unref(MDBBtn), {
                                color: "danger",
                                onClick: ($event: any) => (removePair(pair.kid)),
                                floating: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(MDBIcon), {
                                    icon: "trash",
                                    iconStyle: "fas"
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(MDBAccordion), {
        classes: "mt-3 mb-3",
        modelValue: activeItemAdvanced.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((activeItemAdvanced).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(MDBAccordionItem), {
            headerTitle: "Advanced",
            collapseId: "advanced-section-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(MDBCardText), null, {
                default: _withCtx(() => [
                  _hoisted_37
                ]),
                _: 1
              }),
              _createElementVNode("pre", _hoisted_38, [
                _createElementVNode("code", null, _toDisplayString(JSON.stringify(feedConfiguration.value, null, 4)), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})